
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ethics",
      function () {
        return require("private-next-pages/ethics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ethics"])
      });
    }
  